import { useAppSelector } from 'store/hooks';
import * as selectUser from 'store/user/user.selector';

const useUser = () => {
  const currentUser = useAppSelector(selectUser.currentUser);
  const currentRole = useAppSelector(selectUser.currentRole);

  return { currentUser, currentRole };
};

export default useUser;
